//Icons
import arrowDownWhite from '../../assets/arrow-down-white.svg';
import powerGreen from '../../assets/powerIconGreen.png';
import thunderBlue from '../../assets/thunders/thunder_blue_vector.svg';
import { ReactComponent as ThunderBlueIcon } from '../../assets/thunders/thunder_blue_vector.svg';
import thunderGreen from '../../assets/thunders/thunder_green_vector.svg';
import thunderGrey from '../../assets/thunders/thunder_grey_vector.svg';
import thunderWhite from '../../assets/thunders/thunder_white_vector.svg';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import angle from '../../assets/angle.svg';
import css1 from '../../assets/plugs/CCS1.svg';
import css1White from '../../assets/plugs/CCS1White.svg';
import css2 from '../../assets/plugs/CCS2.svg';
import css2White from '../../assets/plugs/CCS2White.svg';
import chademo from '../../assets/plugs/CHAdeMO.svg';
import chademoWhite from '../../assets/plugs/CHAdeMOWhite.svg';
import j1772 from '../../assets/plugs/J1772.svg';
import j1772White from '../../assets/plugs/J1772White.svg';
import type2 from '../../assets/plugs/Type2.svg';
import type2White from '../../assets/plugs/Type2White.svg';
import roaming from '../../assets/world_roaming_icon.svg';
import roamingCharger from '../../assets/world_roaming_charger_icon.svg';
import { CpStatus } from '../../constants/CpStatus';
import { useAuth } from '../../context/AuthContext';
import { useBrandContext } from '../../context/BrandContext';
import { useToast } from '../../context/ToastModalContext';
import {
  formatCurrency,
  formatHoursMinutes,
  formatKw,
} from '../../utils/format';
import ValueItem from '../valueItem/ValueItem';
import './ChargerStationCard.css';
import { BatteryIcon } from '../../components/BatteryIcon/BatteryIcon';

type ChargerStationCardProps = {
  charger: any;
  isSelected: boolean;
  onClick: any;
};

const ChargerStationCard: React.FC<ChargerStationCardProps> = ({
  charger,
  onClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const authContext = useAuth();
  const [formattedTime, setFormattedTime] = useState<string>('');
  const brandContext = useBrandContext();

  const PERIOD_PRICE_TIME_OVERSTAY_MINUTES =
    charger?.priceProfilePeriod &&
    charger?.priceProfilePeriod?.priceProfilePeriodPriceTimeOverstay
      ? charger?.priceProfilePeriod?.priceProfilePeriodPriceTimeOverstay / 60
      : 0;

  useEffect(() => {
    if (
      charger?.priceProfilePeriod &&
      charger?.priceProfilePeriod?.priceProfilePeriodOverstayGracePeriod
    ) {
      const formatted = formatHoursMinutes(
        charger?.priceProfilePeriod?.priceProfilePeriodOverstayGracePeriod
      );
      setFormattedTime(formatted);
    }
  }, [charger?.priceProfilePeriod?.priceProfilePeriodOverstayGracePeriod]);

  function getPlugIcon() {
    if (charger.cctName.toLowerCase().includes('type2')) {
      if (charger.connectorStatus === 'Available') {
        return type2White;
      } else {
        return type2;
      }
    } else if (charger.cctName.toLowerCase().includes('j1772')) {
      if (charger.connectorStatus === 'Available') {
        return j1772White;
      } else {
        return j1772;
      }
    } else if (charger.cctName.toLowerCase().includes('chademo')) {
      if (charger.connectorStatus === 'Available') {
        return chademoWhite;
      } else {
        return chademo;
      }
    } else if (charger.cctName.toLowerCase().includes('ccs2')) {
      if (charger.connectorStatus === 'Available') {
        return css2White;
      } else {
        return css2;
      }
    } else if (charger.cctName.toLowerCase().includes('ccs1')) {
      if (charger.connectorStatus === 'Available') {
        return css1White;
      } else {
        return css1;
      }
    }
  }

  function getThunderIcon() {
    if (
      charger.cpStatus === CpStatus.OFFLINE &&
      charger.connectorStatus === 'Available'
    ) {
      return thunderGrey;
    } else if (
      charger.cpStatus === CpStatus.ONLINE &&
      charger.connectorStatus === 'Available'
    ) {
      return thunderGreen;
    } else {
      return thunderBlue;
    }
  }

  function getChargerStatus() {
    let return_data = '';
    if (
      charger.cpStatus === CpStatus.OFFLINE &&
      (charger.connectorStatus === null ||
        charger.connectorStatus === 'Available')
    ) {
      return_data = 'Desconectado';
    } else if (charger.connectorStatus === 'Available') {
      return `${formatKw(charger.cmMaxPower)} kW`;
    } else if (charger.connectorStatus === 'Charging') {
      return_data = 'Carregando';
    } else if (charger.connectorStatus === 'Preparing') {
      return_data = 'Preparando';
    } else if (charger.connectorStatus === 'Finishing') {
      return_data = 'Finalizado';
    } else if (charger.connectorStatus === 'SuspendedEV') {
      return_data = 'Finalizando';
    } else if (charger.connectorStatus === 'SuspendedEVSE') {
      return_data = 'Pausado';
    } else if (charger.connectorStatus === 'Unavailable') {
      return_data = 'Indisponível';
    } else if (charger.connectorStatus === 'Faulted') {
      return_data = 'Falha';
    } else {
      return_data = charger.connectorStatus;
    }

    return `${formatKw(charger.cmMaxPower)} kW - ${return_data}`;
  }

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const handleClick = () => {
    if (authContext.user) {
      onClick();
    } else {
      showToast({
        title: `Faça Login`,
        messageModal: `Faça login para iniciar recarga`,
        textEnterButton: 'Ir para login',
        allowButtonClosed: true,
        handleEnterButton: () => navigate(`/${brandContext.brandName}/login`),
        closeButtonText: 'Fechar',
      });
    }
  };

  return (
    <>
      {!isExpanded && (
        <div className='componentContainer' onClick={toggleExpansion}>
          <div className='innerContainer'>
            {charger?.connectorStatus?.toLowerCase() === 'charging' ? (
              <ThunderBlueIcon width={20} height={20} />
            ) : (
              <img
                className='icon'
                loading='lazy'
                alt='thunder-icon'
                src={
                  charger.cpStatus === CpStatus.OFFLINE
                    ? thunderGrey
                    : getThunderIcon()
                }
              />
            )}

            <div className='infoContainer'>
              <div
                className={`title ${
                  getChargerStatus() === 'Desconectado' ? 'title-logged' : ''
                }`}
              >
                {charger.cpCode !== null && charger.cpCode !== undefined
                  ? `${charger.cpCode}-${charger.connectorId}`
                  : null}
                {charger.name && ` - ${charger.name}`}
                {charger?.isOcpi && (
                  <img
                    className='world-roaming-icon'
                    loading='lazy'
                    alt='roaming-icon'
                    src={roaming}
                  />
                )}
              </div>
              <div className='detail'>
                {getChargerStatus()}{' '}
                {charger.cmcType.toLowerCase() === 'dc' &&
                charger.connectorStatus?.toLowerCase() === 'charging' &&
                charger.soC !== null &&
                charger.soC !== undefined ? (
                  <>
                    <div
                      style={{ marginLeft: 10, marginRight: 5, height: '18px' }}
                    >
                      <BatteryIcon
                        percentage={charger.soC}
                        size={18}
                        color='#787e7d'
                      />
                    </div>{' '}
                    {`${
                      charger.soC % 1 < 0.5
                        ? Math.floor(charger.soC)
                        : Math.ceil(charger.soC)
                    }%`}
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <img
            className='rightIcon'
            loading='lazy'
            src={angle}
            alt='right-icon'
          />
        </div>
      )}

      {isExpanded && (
        <div
          className={
            charger.cpStatus === CpStatus.ONLINE
              ? 'mainContainer'
              : 'mainContainerOffline'
          }
          onClick={toggleExpansion}
        >
          <div className='contentContainer'>
            <div className='infoBlock'>
              <div className='infoBlock_blockOne'>
                {charger?.connectorStatus?.toLowerCase() === 'charging' ? (
                  <ThunderBlueIcon width={20} height={20} />
                ) : (
                  <img
                    className='icon'
                    loading='lazy'
                    alt='thunder-white-icon'
                    src={
                      charger.cpStatus === CpStatus.OFFLINE ||
                      charger.connectorStatus === 'Available'
                        ? thunderWhite
                        : getThunderIcon()
                    }
                  />
                )}
                <div className='infoBlock_blockOne-values'>
                  <div className='chargerTitle'>
                    {charger.cpCode !== null && charger.cpCode !== undefined
                      ? `${charger.cpCode}-${charger.connectorId}`
                      : null}
                    {charger.name && ` - ${charger.name}`}
                    {charger?.isOcpi && (
                      <img
                        className='world-roaming-icon'
                        loading='lazy'
                        alt='roaming-icon'
                        src={roamingCharger}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      alignContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div className='power power-charge-on'>
                      {getChargerStatus()}{' '}
                      {charger.cmcType.toLowerCase() === 'dc' &&
                      charger.connectorStatus != null &&
                      charger.connectorStatus.toLowerCase() === 'charging' &&
                      charger.soC !== null &&
                      charger.soC !== undefined ? (
                        <>
                          <div
                            style={{
                              marginLeft: 10,
                              marginRight: 5,
                              height: '18px',
                            }}
                          >
                            <BatteryIcon
                              percentage={charger.soC}
                              size={18}
                              color='#00ffa3'
                            />
                          </div>{' '}
                          {
                            <span style={{ color: '#00ffa3' }}>
                              {charger.soC % 1 < 0.5
                                ? Math.floor(charger.soC)
                                : Math.ceil(charger.soC)}
                              %
                            </span>
                          }
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <img
                className='iconActive'
                loading='lazy'
                alt='arrow-down-white'
                src={arrowDownWhite}
              />
            </div>
            <div className='divider-charger-station-card'> </div>
            <div className='priceDetails'>
              <div className='priceDetails_one'>
                {charger?.priceProfilePeriod?.priceProfilePeriodFreeCharge ? (
                  <div className='charger-station-info-item-price'>
                    Recarga gratuita!{' '}
                  </div>
                ) : (
                  Object.keys(charger).length !== 0 && (
                    <div className='toast-start-charging-info-values'>
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodPriceKwh
                        }
                        paramType=''
                        description=' por kWh utilizado.'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodPriceTimeCharging
                        }
                        paramType=' por hora enquanto o veículo estiver utilizando o carregador.'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodTransactionPrice
                        }
                        paramType=' de taxa de serviço do carregador.'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodPriceTimeParking
                        }
                        paramType='/h Estacionamento'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodPriceTimePlugged
                        }
                        paramType=' por hora enquanto o veículo estiver utilizando o carregador.'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodOverstayPenalty
                        }
                        paramType='/penalidade por ultrapassar o periodo de tolerancia'
                      />

                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodDiscountTotal
                        }
                        paramType='/desconto sobre a cobrança total no final'
                      />
                      <ValueItem
                        valueItemCustomClass='charger-station-info-item-price'
                        valueItemDescriptionCustomClass='charger-station-info-item-description-price'
                        data={
                          charger?.priceProfilePeriod
                            ?.priceProfilePeriodParkingGracePeriod
                        }
                        paramType='/falta definir texto'
                      />
                      {charger?.priceProfilePeriod &&
                        charger?.priceProfilePeriod
                          ?.priceProfilePeriodPriceTimeOverstay != null &&
                        charger?.priceProfilePeriod
                          ?.priceProfilePeriodPriceTimeOverstay > 0 && (
                          <>
                            <br></br>
                            <div className='custom-paragraphs-charging-station-card'>
                              A tolerância após finalizar a recarga será de
                              {` ${formattedTime} `} com o veículo conectado ao
                              carregador.
                            </div>
                            <div className='custom-paragraphs-charging-station-card'>
                              Após esse período será cobrada a taxa de{' '}
                              {`${formatCurrency(
                                PERIOD_PRICE_TIME_OVERSTAY_MINUTES
                              )}`}{' '}
                              por minuto de permanência.
                            </div>
                          </>
                        )}
                    </div>
                  )
                )}
              </div>
              <div className='power power-charge-on'>
                <img
                  loading='lazy'
                  alt='icon-charger-type'
                  src={getPlugIcon()}
                  className='iconChargerType'
                />
                <span style={{ marginLeft: 5 }}>{charger.cctName}</span>
              </div>
            </div>
          </div>
          {(charger.connectorStatus === 'Available' ||
            charger.connectorStatus === 'Preparing') &&
            charger.cpStatus === CpStatus.ONLINE && (
              <div className='startCharging' onClick={() => handleClick()}>
                <div className='startChargingText'>
                  <span>Iniciar recarga</span>
                </div>
                <img alt='icon-charger' loading='lazy' src={powerGreen} />
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default ChargerStationCard;
